import { render, staticRenderFns } from "./CampaignsView.vue?vue&type=template&id=5cc135cc"
import script from "./CampaignsView.vue?vue&type=script&lang=js"
export * from "./CampaignsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports